import { getCandidateProfileData } from '@/api/endpoints/candidateProfile.api'
import { getProfileHub } from '@/api/endpoints/profileHub.api'
import { listRecommendations } from '@/api/endpoints/recommendations.api'
import { prefetch } from '@/shared/utils/prefetch'

export const PROFILE_HUB_KEY = 'candidate:profile-hub'
export const PROFILE_DATA_KEY = 'candidate:profile-data'
export const RECOMMENDATIONS_KEY = 'candidate:recommendations'

export function preloadProfileHub(): void {
  prefetch(PROFILE_HUB_KEY, getProfileHub)
  prefetch(PROFILE_DATA_KEY, getCandidateProfileData)
  prefetch(RECOMMENDATIONS_KEY, listRecommendations)
}
